<template>
  <mail-builders-form-edit
    ref="form"
    v-if="!loading"
    :mail_builder_template_type="mail_builder_template_type"
  ></mail-builders-form-edit>
</template>
<script>
// @ts-check
import Api from '@/store/jsonapi';

export default {
  props: {
    mail_builder_template_type_id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      mail_builder_template_type: {},
      loading: true
    };
  },
  methods: {
    set_breadcrumb() {
      const breadcrumbs = [
        { to: { name: 'settings_index' }, text: this.$t('settings') },
        {
          to: { name: 'mail_builders' },
          text: this.$t('routes_mail_builders')
        },
        {
          to: {
            name: 'mail_builder_edit',
            mail_builder_template_type_id: this.mail_builder_template_type_id
          },
          text: this.mail_builder_template_type.name
        }
      ];
      this.setBreadcrumbs(breadcrumbs);
    }
  },
  async created() {
    let { data } = await Api.find('mail_builder_template_types', this.mail_builder_template_type_id);
    this.mail_builder_template_type = data;

    this.set_breadcrumb();
    this.loading = false;
  }
};
</script>
